import { CorrectOrIncorrect, TranslationData } from "@common";
import { useContext } from "react";

import { StyledButton } from "../components";
import { LangContext } from "../contexts/langContext";
import { SelectAnswerContext } from "../contexts/selectAnswerContext";
import useShowingCorrectAnswer from "../hooks/useShowingCorrectAnswer";
import { getButtonPalletFromCorrectOrIncorrect } from "../util/getButtonPalletFromCorrectOrIncorrect";

interface RenderProps {
  option1Text: TranslationData;
  option1IsCorrect: CorrectOrIncorrect;
  option2Text: TranslationData;
  option2IsCorrect: CorrectOrIncorrect;
  option3Text: TranslationData;
  option3IsCorrect: CorrectOrIncorrect;
  option4Text: TranslationData;
  option4IsCorrect: CorrectOrIncorrect;
  readOnly?: boolean;
  showCorrect?: boolean;
}

const SeveralOption: React.FC<{
  [key in keyof RenderProps]: RenderProps[key];
}> = ({
  option1Text,
  option1IsCorrect,
  option2Text,
  option2IsCorrect,
  option3Text,
  option3IsCorrect,
  option4Text,
  option4IsCorrect,
  readOnly = false,
  showCorrect = false,
}) => {
  const { translateTranslationData } = useContext(LangContext);
  const { onSelectAnswer } = useContext(SelectAnswerContext);
  const showingCorrectAnswer = useShowingCorrectAnswer();
  const displayCorrectAnswers = showCorrect || showingCorrectAnswer;

  return (
    <>
      <OptionButton
        handleClick={() =>
          onSelectAnswer(option1IsCorrect, {
            bar1: 1,
            bar2: 0,
            bar3: 0,
            bar4: 0,
            bar5: 0,
          })
        }
        text={translateTranslationData(option1Text)}
        readOnly={readOnly}
        showCorrect={displayCorrectAnswers}
        isCorrect={option1IsCorrect}
      />
      <OptionButton
        handleClick={() =>
          onSelectAnswer(option2IsCorrect, {
            bar1: 0,
            bar2: 1,
            bar3: 0,
            bar4: 0,
            bar5: 0,
          })
        }
        text={translateTranslationData(option2Text)}
        readOnly={readOnly}
        showCorrect={displayCorrectAnswers}
        isCorrect={option2IsCorrect}
      />
      <OptionButton
        handleClick={() =>
          onSelectAnswer(option3IsCorrect, {
            bar1: 0,
            bar2: 0,
            bar3: 1,
            bar4: 0,
            bar5: 0,
          })
        }
        text={translateTranslationData(option3Text)}
        readOnly={readOnly}
        showCorrect={displayCorrectAnswers}
        isCorrect={option3IsCorrect}
      />
      <OptionButton
        handleClick={() =>
          onSelectAnswer(option4IsCorrect, {
            bar1: 0,
            bar2: 0,
            bar3: 0,
            bar4: 1,
            bar5: 0,
          })
        }
        text={translateTranslationData(option4Text)}
        readOnly={readOnly}
        showCorrect={displayCorrectAnswers}
        isCorrect={option4IsCorrect}
      />
    </>
  );
};

const OptionButton: React.FC<{
  handleClick: any;
  text: string;
  readOnly?: boolean;
  showCorrect?: boolean;
  isCorrect: CorrectOrIncorrect;
}> = ({ handleClick, text, readOnly = false, showCorrect = false, isCorrect }) => {
  if (text === "") return null;
  return (
    <StyledButton
      hasCooldown
      onClick={handleClick}
      fullWidth
      style={{ margin: "4px 0" }}
      label={text}
      clickable={showCorrect === false}
      palette={getButtonPalletFromCorrectOrIncorrect(showCorrect, isCorrect)}
    />
  );
};

export default SeveralOption;
